// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3Mz1I","logo":"styles_logo__3vjOL","header-content":"styles_header-content__2JjVI"};